<template>
  <v-container id="data-tables" tag="section" fluid>
    <base-material-card color="primary" icon="mdi-broom" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Saneamento do VOC</div>
      </template>

      <v-btn
        id="btn-novo-calculo"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push(`edit`)"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVO CÁLCULO
      </v-btn>

      <v-text-field
        id="saneamento-voc-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-saneamento-voc ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Saneamento do VOC" />

      <v-divider class="mt-10" />

      <v-data-table
        class="saneamento-voc-table"
        :headers="headers"
        :items="calculos"
        :search.sync="search"
        :loading="loadingItems"
        no-data-text="Nenhum Saneamento do VOC disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :header-props="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        mobile-breakpoint="800"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column"
                :class="['EXECUTANDO', 'AGUARDANDO'].includes(item.status) ? 'clickable-item' : ''"
                v-bind="attrs"
                @click="openDialogAcompanhamento(item)"
                v-on="on"
              >
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.executed`]="{ item }">
          {{ item.executed }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-saneamento-voc"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-saneamento-voc"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-saneamento-voc"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-play</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Executar</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.status == 'SUCESSO' && item.parametros.calculoDeCA == 1"
                @click="$router.push(`/saneamento-voc/analiticos-ca/historico/${item.id}`)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-chart-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Analíticos de CA</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.status == 'SUCESSO'" @click="duplicarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Duplicar</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Deletar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-file-find-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Detalhes</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Saneamento do VOC #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes do Cálculo"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        >
          <template v-slot:item="row">
            <tr>
              <td
                class="button"
                :class="{
                  'font-weight-bold':
                    row.item.parametro === 'CMU' || row.item.parametro === 'Parâmetros para a Racionalização do COM'
                }"
                width="210px"
              >
                {{ row.item.parametro }}
              </td>
              <td v-if="row.item.tipo === 'tabela'">
                <div
                  :class="{
                    'scrollable-columns': Object.keys(Object.values(row.item.valor)[0]).length > 5
                  }"
                >
                  <table class="button">
                    <thead>
                      <tr>
                        <th style="border: none"></th>
                        <th v-for="coluna in Object.keys(Object.values(row.item.valor)[0])" :key="coluna" style="border: none">
                          {{ coluna }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(colunas, linha) in row.item.valor" :key="linha">
                        <th style="border: none">{{ linha }}</th>
                        <td v-for="(valor, coluna) in colunas" :key="coluna" style="border: none">
                          {{ valor }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
              <td
                v-else-if="row.item.parametro.indexOf('OBRAS') == -1 && row.item.parametro.indexOf('TIPOLOGIAS') == -1"
                class="button"
              >
                {{ row.item.valor }}
              </td>
              <td v-else class="button" style="padding-left: 0px !important">
                <v-textarea rows="5" no-resize readonly class="ml-4 mt-0 pt-0" :value="row.item.valor" />
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
    <general-dialog-acompanhamento
      ref="dialogAcompanhamento"
      :show-dialog="dialogAcompanhamento"
      :messages="dialogAcompanhamentoData.andamento"
      :name-event-pusher="'andamento-calculo-com-ca-aneel-' + dialogAcompanhamentoData.id"
      @changeValue="dialogAcompanhamento = $event"
    >
      <template slot="title">Andamento do Saneamento do VOC #{{ dialogAcompanhamentoData.id }}</template>
    </general-dialog-acompanhamento>
  </v-container>
</template>

<script>
  import SaneamentoVocService from '@/services/SaneamentoVocService.js';
  import powerupsActionsMixis from '@/mixins/powerupsActionsMixins.js';

  export default {
    name: 'SaneamentoVocDataTable',

    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
      GeneralDialogAcompanhamento: () => import('@/components/general/GeneralDialogAcompanhamento')
    },

    mixins: [powerupsActionsMixis],

    props: {
      calculos: {
        type: Array,
        default: () => []
      },
      loadingItems: {
        type: Boolean,
        default: false
      }
    },

    emits: ['switchProcessamentosExpirados'],

    data: () => ({
      powerupService: SaneamentoVocService,
      powerupEntityName: 'Saneamento do VOC',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    methods: {
      openDialogDetalhes(calculo) {
        const tiposDeCalculo = [
          { nome: 'Percentuais de COM e CA', ativo: calculo.parametros.calculoDeCA },
          { nome: 'Racionalização do COM', ativo: calculo.parametros.racionalizacaoDoCOM }
        ];

        const labelObras = calculo.filtros.obrasNaoPertencemALista ? 'OBRAS NÃO PERTENCEM A:' : 'OBRAS:';
        const labelTipologias = calculo.filtros.tipologiasNaoPertencemALista ? 'TIPOLOGIAS NÃO PERTENCEM A:' : 'TIPOLOGIAS:';

        this.dialogDetalhesData = [
          {
            parametro: 'NOME:',
            valor: calculo.nome
          },
          {
            parametro: 'TIPOS DE CÁLCULOS:',
            valor: tiposDeCalculo
              .filter((el) => el.ativo)
              .map((el) => el.nome)
              .join(', ')
          },
          {
            parametro: labelObras,
            valor: calculo.filtros.obras
          },
          {
            parametro: labelTipologias,
            valor: calculo.filtros.tipologias
          },
          {
            parametro: 'DATA DE IMOBILIZAÇÃO DE:',
            valor: calculo.filtros.dataImobilizacaoInicial ? calculo.filtros.dataImobilizacaoInicial : '-'
          },
          {
            parametro: 'DATA DE IMOBILIZAÇÃO ATÉ:',
            valor: calculo.filtros.dataImobilizacaoFinal ? calculo.filtros.dataImobilizacaoFinal : '-'
          }
        ];

        if (calculo.parametros.calculoDeCA) {
          const flagsAplicacaoList = [
            { text: 'NÃO APLICAR', value: 'NAO_APLICAR' },
            { text: 'APLICAR NA OBRA', value: 'APLICAR_NA_OBRA' },
            { text: 'APLICAR NOS LANÇAMENTOS', value: 'APLICAR_NOS_LANCAMENTOS' }
          ];
          const flagUarZeroAplicacao = calculo.parametros.FLG_ODI_UAR_ZERO?.aplicar;
          const flagDataAplicacao = calculo.parametros.FLG_ERR_DT_LMTO?.aplicar;

          this.dialogDetalhesData = this.dialogDetalhesData.concat([
            {
              parametro: 'FLAG OBRA COM UAR <= 10%:',
              valor: flagUarZeroAplicacao ? flagsAplicacaoList.find((el) => el.value == flagUarZeroAplicacao).text : 'NÃO APLICAR'
            },
            {
              parametro: 'FLAG DATA:',
              valor: flagDataAplicacao ? flagsAplicacaoList.find((el) => el.value == flagDataAplicacao).text : 'NÃO APLICAR'
            },
            {
              parametro: 'PERCENTUAL PADRÃO PARA JOA:',
              valor: calculo.parametros.percentuais_padroes['JOA'] ?? '-'
            },
            {
              parametro: 'PERCENTUAL PADRÃO PARA MATERIAL - COM:',
              valor: calculo.parametros.percentuais_padroes['Material - COM'] ?? '-'
            },
            {
              parametro: 'PERCENTUAL PADRÃO PARA MATERIAL - UAR:',
              valor: calculo.parametros.percentuais_padroes['Material - UAR'] ?? '-'
            },
            {
              parametro: 'PERCENTUAL PADRÃO PARA MOP:',
              valor: calculo.parametros.percentuais_padroes['MOP'] ?? '-'
            },
            {
              parametro: 'PERCENTUAL PADRÃO PARA SERVIÇOS TÉCNICOS:',
              valor: calculo.parametros.percentuais_padroes['Serv. Terc.'] ?? '-'
            },
            {
              parametro: 'PERCENTUAL PADRÃO PARA OUTROS:',
              valor: calculo.parametros.percentuais_padroes['Outros'] ?? '-'
            }
          ]);
        }

        if (calculo.parametros.FLG_ERR_DT_LMTO && calculo.parametros.FLG_ERR_DT_LMTO.aplicar !== 'NAO_APLICAR') {
          const infos = calculo.parametros.FLG_ERR_DT_LMTO;
          this.dialogDetalhesData = this.dialogDetalhesData.concat([
            {
              parametro: 'Perc. OK:',
              valor: infos.perc_ok ?? '-'
            },
            {
              parametro: 'Perc. Falha:',
              valor: infos.perc_falha ?? '-'
            },
            {
              parametro: 'Nº de dias (antes da data de imobilização):',
              valor: infos.numDiasAntes + ' dias' ?? '-'
            },
            {
              parametro: 'Nº de dias (depois da data de imobilização):',
              valor: infos.numDiasDepois + ' dias' ?? '-'
            },
            {
              parametro: 'Incluir janela na data de imobilização?',
              valor: infos.incluirJanelaDataImobilizacao > 0 ? 'Sim' : 'Não'
            }
          ]);
        }

        if (calculo.parametros.siglas_aneel_valores && Object.keys(calculo.parametros.siglas_aneel_valores).length > 0) {
          const siglas = calculo.parametros.siglas_aneel_valores;
          const detalhes = [];

          for (const sigla in siglas) {
            const anos = {};

            for (const tipologia in siglas[sigla]) {
              anos[tipologia] = siglas[sigla][tipologia];
            }

            detalhes.push({
              parametro: sigla,
              valor: anos,
              tipo: 'tabela'
            });
          }

          this.dialogDetalhesData = this.dialogDetalhesData.concat([
            {
              parametro: 'CMU',
              valor: ''
            },
            {
              parametro: 'Sigla Aneel',
              valor: 'Custo Médio por Ano'
            }
          ]);
          this.dialogDetalhesData = this.dialogDetalhesData.concat(detalhes);
        }

        if (calculo.parametros.normas_quantidades_com && Object.keys(calculo.parametros.normas_quantidades_com).length > 0) {
          const normas = calculo.parametros.normas_quantidades_com;
          const detalhes = [];

          for (const norma in normas) {
            const tipologia = {};

            for (const equipamento in normas[norma]) {
              tipologia[equipamento] = normas[norma][equipamento];
            }

            detalhes.push({
              parametro: norma,
              valor: tipologia,
              tipo: 'tabela'
            });
          }

          this.dialogDetalhesData = this.dialogDetalhesData.concat([
            {
              parametro: 'Parâmetros para a Racionalização do COM',
              valor: ''
            },
            {
              parametro: 'Equipamento',
              valor: 'Quantidade por Tipologia e Componente Menor'
            }
          ]);
          this.dialogDetalhesData = this.dialogDetalhesData.concat(detalhes);
        }

        this.dialogDetalhes = true;
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .saneamento-voc-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .saneamento-voc-table table tr td:nth-child(6),
    .saneamento-voc-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-saneamento-voc {
      width: 209.91px !important;
    }
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }

  .scrollable-columns {
    overflow-x: auto;
  }
</style>